export const L10N = {
  ACTION_BOOK_NOW: { id: 'core.action.book_now' },
};
